<subpage-layout>
    <p class="subpage-tooltip">
        Enter 4-digit <br/>
        PIN to unlock
    </p>

    <div class="code-confirm_wrap">
        <input class="code-confirm"
                [ngClass]="{'red-underline': wrongPin}"
                maxlength='4'
                inputmode="numeric"
                #pinInput
                (input)='onChange()'
                (keypress)="numberOnly($event)"
                [(ngModel)]='pin' />
    </div>

    <p class="subpage-tooltip_error red">
        <span *ngIf="wrongPin">PIN-code is incorrect</span>
        <span *ngIf="smthWrong">Something went wrong. Please try again</span>
    </p>

    <div class="bio-icon_wrap">
        <ion-icon *ngIf="!hideBio && enabledBio"
                    size="large"
                    class="bio-icon"
                    (click)="checkBio()"
                    src="assets/biometry.svg"
                    alt="Biometry">
        </ion-icon>

        <ion-icon *ngIf="!hideBio && !enabledBio"
                size="large"
                class="bio-icon"
                src="assets/biometry-inactive.svg"
                alt="Biometry">
        </ion-icon>
    </div>

    <div class="align-center">
        <ion-button class="link-styled"
                    (click)="forgotPinClicked()"
                    fill="clear">Forgot PIN?
        </ion-button>
    
        <ion-button class="link-styled underlined"
                    (click)="openSupportModal.emit(true)"
                    fill="clear">Contact Support
        </ion-button>
    </div>
</subpage-layout>

<contact-support-form [openModal]="openSupportModal"></contact-support-form>